export enum FeatureEntitlements {
  InsightsBenchmarkMetricsEntitlement = 'insights_benchmark_metrics',
  AdsSurfaceFilterEntitlement = 'ads_surface_filter',
}
